import _includes from "lodash/includes";
import _get from "lodash/get";
export var getHasVerifiedPhone = function getHasVerifiedPhone(identity) {
  var roles = _get(identity, 'current.roles', []);

  return _includes(roles, 'nerdwallet/has_verified_phone');
};